import { render, staticRenderFns } from "./CommonRouterView.vue?vue&type=template&id=01bdb484&"
var script = {}


/* normalize component */
import normalizer from "!../../../sis/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports